import React from 'react';
import { getCurrency, getShortDate, maskNumberString } from '../../Helper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle, faSquare } from '@fortawesome/free-regular-svg-icons';
import { faCheckCircle, faCheckSquare, faCreditCard, faUser, faCalendarAlt, faMapMarkerAlt, faMoneyCheck, faMoneyCheckAlt } from '@fortawesome/free-solid-svg-icons';
import FeeTable from '../Fee/FeeTable';

function ReviewAndSubmitPayment(props) {

    const totalBalanceDue = 0;
    const totalPaymentAmount = 0;
    /*let reviewFeesJSX = (
        <table className="table">
            <thead>
                <tr>
                    {props.options.accountNumber ?
                        <th>Account Number</th>
                    : null}
                    {props.options.identifier ?
                        <th>Permit Number/EPA ID</th>
                    : null}
                    {props.options.division ?
                        <th>Program</th>
                    : null}
                    {props.options.description ?
                        <th>Description</th>
                    : null}
                    {props.options.balance ?
                        <th>Balance Due</th>
                    : null}
                    {props.options.paymentAmount ?
                        <th>Payment Amount</th>
                    : null}
                </tr>
            </thead>
            <tbody>
                {props.feePayments.filter(fp => fp.paymentAmount > 0).map(fp => {
                    const f = props.fees.find(f => f.feeID === fp.feeID);
                    if (!f) return null;
                    return (<tr key={fp.feeID}>
                        {props.options.accountNumber ?
                            <td>
                                {f.account.accountNumber}
                            </td>
                        : null}
                        {props.options.identifier ?
                            <td>
                                {f.identifier}
                            </td>
                        : null}
                        {props.options.division ?
                            <td>
                                {f.division?.divisionName}
                            </td>
                        : null}
                        {props.options.description ?
                            <td>
                                {f.feeDescription}
                            </td>
                        : null}
                        {props.options.paymentAmount ?
                            <td>
                                {getCurrency(fp.paymentAmount)}
                            </td>
                        : null}
                    </tr>)
                })}
            </tbody>
            <tfoot>
                <tr>
                    {props.options.accountNumber ?
                        <td>
                        </td>
                    : null}
                    {props.options.identifier ?
                        <td>
                        </td>
                    : null}
                    {props.options.division ?
                        <td>
                        </td>
                    : null}
                    {props.options.description ?
                        <td>
                        </td>
                        : null}
                    {props.options.paymentAmount ?
                        <td>
                            <strong>{getCurrency(totalBalanceDue)}</strong>
                        </td>
                        : null}
                    {props.options.paymentAmount ?
                        <td>
                            <strong>{getCurrency(totalPaymentAmount)}</strong>
                        </td>
                    : null}
                </tr>
            </tfoot>
        </table>
    );*/

    const feeOptions = {
        fields: {
            accountNumber: true,
            account: false,
            division: true,
            facility: true,
            identifier: true,
            description: true,
            fiscalYear: true,
            amount: false,
            balance: true,
            dueDate: true,
            paidInFull: false,
            actions: false
        },
        footer: {
            amountTotal: false,
            balanceTotal: false
        },
        actions: {
            add: false,
            view: false,
            edit: false,
            delete: false,
            viewAccount: false
        }
    };

    const feeBalance = props.fees.map(f => f.currentBalance).reduce((a, b) => a + b, 0);
    let totalBalance = feeBalance;

    switch (props.paymentInfo.sslTransactionType) {
        case 'ccsale':
            //totalBalance = Math.ceil(100 * feeBalance / 0.975) / 100;
            totalBalance = Math.ceil(100 * feeBalance * 1.025) / 100;
            break;
        case 'ecspurchase':
            totalBalance = feeBalance + 0.25;
            break;
        default:
            break;
    }

    const processingFee = totalBalance - feeBalance;
    const reviewFeesJSX = (
        <div className="fees-review">
            <div className="total-due"><span className="total-due-label">Total Due:</span><span className="total-due-value">{getCurrency(totalBalance)}</span></div>
            {props.fees.length > 0 ? (<FeeTable fees={props.fees} options={feeOptions} />) : null}
            <div className="totals">
                <div className="subtotal"><span className="subtotal-label">Subtotal:</span><span className="subtotal-value">{getCurrency(feeBalance)}</span></div>
                <div className="processing-fee"><span className="processing-fee-label">Processing Fee:</span><span className="processing-fee-value">{getCurrency(processingFee)}</span></div>
                <div className="grand-total"><span className="grand-total-label">Grand Total:</span><span className="grand-total-value">{getCurrency(totalBalance)}</span></div>
            </div>
        </div>
    );

    let reviewPaymentJSX = null;
    switch (props.paymentInfo.sslTransactionType) {
        case 'ccsale':
            reviewPaymentJSX = (
                <div className="payment-info-review">
                    <div><span className="label">Credit Card:</span><span className="value">{maskNumberString(props.paymentInfo.sslCardNumber, 4, "*")}</span></div>
                    <div><span className="label">Name:</span><span className="value">{(props.paymentInfo.sslFirstName || '') + ' ' + (props.paymentInfo.sslLastName || '')}</span></div>
                    <div><span className="label">Address:</span><span className="value">{(props.paymentInfo.sslAvsAddress || '') + ' ' + (props.paymentInfo.sslCity || '') + ', ' + (props.paymentInfo.sslState || '') + ' ' + (props.paymentInfo.sslAvsZip || '')}</span></div>
                </div>
            );
            break;
        case 'ecspurchase':
            reviewPaymentJSX = (
                <div className="payment-info-review">
                    <div><span className="label">eCheck:</span><span className="value">{maskNumberString(props.paymentInfo.sslBankAccountNumber, 4, "*")}</span></div>
                    <div><span className="label">Name:</span><span className="value">{(props.paymentInfo.sslFirstName || '') + ' ' + (props.paymentInfo.sslLastName || '')}</span></div>
                    <div><span className="label">Address:</span><span className="value">{(props.paymentInfo.sslAvsAddress || '') + ' ' + (props.paymentInfo.sslCity || '') + ', ' + (props.paymentInfo.sslState || '') + ' ' + (props.paymentInfo.sslAvsZip || '')}</span></div>
                </div>
            );
            break;
        case 'pc':
            reviewPaymentJSX = (
                <div className="payment-info-review">
                    <div><span className="label">Paper Check:</span><span className="value">{props.paymentInfo.CheckNum}</span></div>
                    <div><span className="label">DANR Program:</span><span className="value">{props.paymentInfo.Program}</span></div>
                    <div><span className="label">Payment For:</span><span className="value">{props.paymentInfo.FeeType}</span></div>
                    <div><span className="label">Check From:</span><span className="value">{props.paymentInfo.CheckFrom}</span></div>
                    <div><span className="label">Check Amount:</span><span className="value">{getCurrency(props.paymentInfo.Amount)}</span></div>
                    <div><span className="label">Check Date:</span><span className="value">{getShortDate(props.paymentInfo.CheckDate)}</span></div>
                    <div><span className="label">Received Date:</span><span className="value">{getShortDate(props.paymentInfo.RecdDate)}</span></div>
                </div>
            );
            break;
        default:
            break;
    }

    return (
        <div className="review-and-submit">
            {reviewFeesJSX}
            {reviewPaymentJSX}
        </div>
    );
}

export default ReviewAndSubmitPayment;